import { ajax } from 'rxjs/ajax'
import uuid from 'uuidv4'
import { getPublicServerUrl } from './constants'

import * as RasaCookies from 'generic/cookies'
import * as AuthConstants from 'auth/constants'

export const isLocal = (): boolean => {
  return window.location.href.startsWith('http://localhost:')
}

// Mirrors the onboarding-api allowlist in src/shared_server/services/dashboardRedirect.ts —
// permits *.rasa.io over https plus localhost/127.0.0.1 for dev. Used as defense-in-depth
// before following a backend-supplied redirect URL.
const ALLOWED_REDIRECT_HOSTS = ['.rasa.io']

export const isAllowedRedirectUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url)
    if (parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1') {
      return true
    }
    return parsed.protocol === 'https:' &&
      ALLOWED_REDIRECT_HOSTS.some((host) => parsed.hostname === host.slice(1) || parsed.hostname.endsWith(host))
  } catch {
    return false
  }
}

export const isSameOrigin = (url: string): boolean => {
  try {
    return new URL(url).host === window.location.host
  } catch {
    return false
  }
}

export const redirectTo = (host: string, queryParams: string[]) => {
  const cookie: RasaCookies.RasaCookie = {
    maxAge: 30,
    name: `t${Date.now()}`,
    value: window.localStorage.getItem(AuthConstants.RASA_AUTH_TOKEN),
  }
  RasaCookies.setCookie(cookie)

  let url: URL;
  try {
    url = new URL(host);
  } catch (error) {
    url = new URL(window.location.origin);
  }

  queryParams.push(`${RasaCookies.REDIRECT_COOKIE_PARAM}=${cookie.name}`);

  url.search = queryParams.join('&');
  window.location.href = url.toString();
}

export const generateGuid = () => uuid()

export const writeLog = (payload) => {
  if ( process.env.SKIP_LOG ) {
    return
  } else {
    try {
      const url: string = getPublicServerUrl() + '/monitoring/dashboard/log'
      const headers = {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'rxjs-custom-header': 'Rxjs',
      }
      return ajax({
        body: payload,
        headers,
        method: 'POST',
        url,
      }).toPromise()
    } catch (error) {
      // do nothing. No need to print. Error would in the network
    }
  }
}
